<template>
  <div>
    <Header :title="title" :showBack="true"></Header>
    <div class="SalePayment">
      <!-- 售票员信息 -->
      <div class="aBlock">
        <div class="title">售票员信息</div>
        <div class="wrap">
          <span>缴款时间：</span>
          <input disabled type="text" />
        </div>
        <div class="wrap">
          <span>售票开始时间：</span>
          <input disabled v-model="dataList[0].SaleBeginDateTime" type="text" />
        </div>
        <div class="wrap">
          <span>售票截止日期：</span>
          <input disabled v-model="dataList[0].SaleEndDateTime" type="text" />
        </div>
        <div class="wrap">
          <span>缴款单号：</span>
          <input disabled type="text" />
        </div>
        <div class="wrap">
          <span>售票员代码：</span>
          <input disabled v-model="dataList[0].SellerCode" type="text" />
        </div>
        <div class="wrap">
          <span>售票员名称</span>
          <input disabled v-model="dataList[0].SellerName" type="text" />
        </div>
        <div class="wrap">
          <span>缴款金额：</span>
          <input disabled v-model="dataList[0].PaymentAmount" type="text" />
        </div>
      </div>
      <!-- 打印取票记录 -->
      <div class="aBlock">
        <div class="title">打印取票记录</div>
        <div class="wrap">
          <span>打印张数：</span>
          <input disabled v-model="dataList[0].PrintTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>打印金额：</span>
          <input disabled v-model="dataList[0].PrintTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>取票张数：</span>
          <input disabled v-model="dataList[0].OutTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>取票金额：</span>
          <input disabled v-model="dataList[0].OutTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>复打张数：</span>
          <input disabled v-model="dataList[0].CopyTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>复打金额：</span>
          <input disabled v-model="dataList[0].CopyTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>计费张数：</span>
          <input disabled v-model="dataList[0].ChargeTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>计费金额：</span>
          <input disabled v-model="dataList[0].ChargeTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>现金票数：</span>
          <input disabled v-model="dataList[0].CashTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>现金金额：</span>
          <input disabled v-model="dataList[0].CashTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>非现金票数：</span>
          <input disabled v-model="dataList[0].NonCashTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>非现金金额：</span>
          <input disabled v-model="dataList[0].NonCashTicketAmount" type="text" />
        </div>
      </div>
      <!-- 退改废票信息 -->
      <div class="aBlock">
        <div class="title">退改废票信息</div>
        <div class="wrap">
          <span>退票张数：</span>
          <input disabled v-model="dataList[0].RefundTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>退票手续费：</span>
          <input disabled v-model="dataList[0].RefundTicketFee" type="text" />
        </div>
        <div class="wrap">
          <span>退票金额：</span>
          <input disabled v-model="dataList[0].RefundTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>废票张数：</span>
          <input disabled v-model="dataList[0].DelTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>改签张数：</span>
          <input disabled v-model="dataList[0].ChangeTicketCount" type="text" />
        </div>
        <div class="wrap">
          <span>改签金额：</span>
          <input disabled v-model="dataList[0].ChangeTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>改签手续费：</span>
          <input disabled v-model="dataList[0].ChangeTicketFee" type="text" />
        </div>
        <div class="wrap">
          <span>废票金额：</span>
          <input disabled v-model="dataList[0].DelTicketAmount" type="text" />
        </div>
        <div class="wrap">
          <span>现金退票张数：</span>
          <input disabled v-model="dataList[0].CashRefundCount" type="text" />
        </div>
        <div class="wrap">
          <span>现金退还金额：</span>
          <input disabled v-model="dataList[0].CashRefundAmount" type="text" />
        </div>
        <div class="wrap">
          <span>非现金退票张数：</span>
          <input disabled v-model="dataList[0].NonCashRefundCount" type="text" />
        </div>
        <div class="wrap">
          <span>非现金退还金额：</span>
          <input disabled v-model="dataList[0].NonCashRefundAmount" type="text" />
        </div>
      </div>
      <!-- 收款人信息 -->
      <div class="aBlock">
        <div class="title">收款人信息</div>
        <div class="wrap">
          <span>收款人代码：</span>
          <input disabled type="text" />
        </div>
        <div class="wrap">
          <span>收款人名称：</span>
          <input disabled type="text" />
        </div>
        <div class="wrap">
          <span>收款时间：</span>
          <input disabled type="text" />
        </div>
      </div>
      <!-- 收款金额计算 -->
      <div class="aBlock">
        <div class="title">收款金额计算</div>
        <div class="computed">
          <div>计算公式：</div>
          <input disabled value="应缴金额 = 现金金额 - 现金退还金额 - 废票金额 - 改签金额" type="text" />
          <div>计算结果：</div>
          <input disabled type="text" v-model="computedResult" />
        </div>
      </div>

      <div @click="paymentClick" class="SalePaymentSubmit">缴款</div>
      <div @click="printClick" class="print">打印</div>
      <div v-if="isRefresh" @click="refreshClick" class="refresh">刷新</div>
      <div @click="lastClick" class="last">上一条</div>
      <div @click="nextClick" class="next">下一条</div>

      <van-popup
        v-model="SalePaymentSubmitPopup"
        position="center"
        :overlay="true"
        class="SalePaymentSubmitPopup"
      >
        <div class="tips">小提示</div>
        <div class="content">您确定要提交缴款单吗</div>
        <div class="btn">
          <span @click="confirmSubmit">确定</span>
          <span @click="cancelSubmit">取消</span>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      title: "售票缴款", //标题
      dataList: [
        {
          CashRefundAmount: null,
          CashRefundCount: null,
          CashTicketAmount: null,
          CashTicketCount: null,
          ChangeTicketAmount: null,
          ChangeTicketCount: null,
          ChangeTicketFee: null,
          ChargeTicketAmount: null,
          ChargeTicketCount: null,
          CompGID: null,
          CopyTicketAmount: null,
          CopyTicketCount: null,
          CreateTime: null,
          DelTicketAmount: null,
          DelTicketCount: null,
          GID: null,
          NonCashRefundAmount: null,
          NonCashRefundCount: null,
          NonCashTicketAmount: null,
          NonCashTicketCount: null,
          OpBeginDateTime: null,
          OpEndDateTime: null,
          OutTicketAmount: null,
          OutTicketCount: null,
          PayeeCode: null,
          PayeeGID: null,
          PayeeName: null,
          PayeeTime: null,
          PaymentAmount: null,
          PaymentNo: null,
          PaymentStatusID: null,
          PaymentTime: null,
          PrintTicketAmount: null,
          PrintTicketCount: null,
          RefundTicketAmount: null,
          RefundTicketCount: null,
          RefundTicketFee: null,
          SellerCode: null,
          SellerGID: null,
          SellerName: null
        }
      ], // 缴款表的数据
      originDataList: [
        {
          CashRefundAmount: null,
          CashRefundCount: null,
          CashTicketAmount: null,
          CashTicketCount: null,
          ChangeTicketAmount: null,
          ChangeTicketCount: null,
          ChangeTicketFee: null,
          ChargeTicketAmount: null,
          ChargeTicketCount: null,
          CompGID: null,
          CopyTicketAmount: null,
          CopyTicketCount: null,
          CreateTime: null,
          DelTicketAmount: null,
          DelTicketCount: null,
          GID: null,
          NonCashRefundAmount: null,
          NonCashRefundCount: null,
          NonCashTicketAmount: null,
          NonCashTicketCount: null,
          OpBeginDateTime: null,
          OpEndDateTime: null,
          OutTicketAmount: null,
          OutTicketCount: null,
          PayeeCode: null,
          PayeeGID: null,
          PayeeName: null,
          PayeeTime: null,
          PaymentAmount: null,
          PaymentNo: null,
          PaymentStatusID: null,
          PaymentTime: null,
          PrintTicketAmount: null,
          PrintTicketCount: null,
          RefundTicketAmount: null,
          RefundTicketCount: null,
          RefundTicketFee: null,
          SellerCode: null,
          SellerGID: null,
          SellerName: null
        }
      ], // 缴款表的初始数据
      originDataListIsEmpty: false, // 初始数据是否为空
      computedResult: null, // 应缴款金额
      GID: null,
      OpEndTime: "",
      SalePaymentSubmitPopup: false, // 提交缴款单弹出层
      isRefresh: true, // 刷新按钮的显示状态
      lastClickState: false, // 上一次点击的是否为 上一条last 则设置其为true
      lastClickOpDate: null, // 如果这次点击为下一条，上一次点击为上一条， 使用上一次点击的OpDate
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")) // 操作员 对象
    };
  },
  methods: {
    getTicketSalePayment(state, time) {
      let params = {
        UserGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        OpDate: time ? time : new Date(),
        PayStatusID: 1,
        ActionName: state
      };
      this.$http
        .post(this.$api.TicketSalePaymentQuery, this.$qs.stringify(params))
        .then(res => {
          console.log(res);
          if (res.success) {
            if (res.data.length > 0) {
              this.dataList = res.data;
              this.computedResult =
                this.dataList[0].PaymentAmount +
                " = " +
                this.dataList[0].CashTicketAmount +
                " - " +
                this.dataList[0].CashRefundAmount +
                " - " +
                this.dataList[0].DelTicketAmount +
                " - " +
                this.dataList[0].ChangeTicketAmount;
              this.GID = this.dataList[0].GID;
              this.OpEndTime = this.dataList[0].OpEndDateTime;
              if (this.dataList[0].PaymentTime) {
                this.isRefresh = false;
              } else {
                this.isRefresh = true;
              }
            }
            if (res.data.length == 0) {
              if (state == "last") {
                this.$dialog
                  .alert({
                    title: "提示",
                    message: "已经没有上一条缴款单记录。"
                  })
                  .then(() => {
                    // on close
                  });
                this.lastClickState = false;
              } else if (state == "next" && res.data.length < 1) {
                this.$dialog
                  .alert({
                    title: "提示",
                    message: "已经没有下一条缴款单记录。"
                  })
                  .then(() => {
                    // on close
                  });
              } else {
                this.dataList = this.originDataList;
                this.computedResult = null;
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.alert({
            title: "提示",
            message: err
          });
        });
    },
    // 点击刷新
    refreshClick() {
      this.getTicketSalePayment();
      console.log(this.dataList);
    },
    // 点击缴款
    paymentClick() {
      if (this.dataList[0].PaymentTime) {
        this.$dialog.alert({
          title: "操作提示",
          message: "该缴款单已提交，请勿重复提交"
        });
      } else {
        this.SalePaymentSubmitPopup = true;
      }
    },
    // 确定缴款
    confirmSubmit() {
      this.SalePaymentSubmitPopup = false;
      let params = {
        GID: this.GID,
        OpEndTime: this.OpEndTime
      };
      this.$http
        .post(this.$api.TicketSalePaymentSubmit, this.$qs.stringify(params))
        .then(res => {
          console.log(res);
          if (res.success) {
            this.$toast("缴款成功");
            this.dataList = this.originDataList;
            this.computedResult = null;
            this.lastClick();
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.alert({
            title: "提示",
            message: err
          });
        });
    },
    // 取消缴款
    cancelSubmit() {
      this.SalePaymentSubmitPopup = false;
    },
    // 上一条的点击事件
    lastClick() {
      if (!this.dataList[0].GID) {
        this.originDataListIsEmpty = true;
      }
      this.getTicketSalePayment("last", this.dataList[0].OpBeginDateTime);
      this.lastClickState = true;
      this.lastClickOpDate = this.dataList[0].OpBeginDateTime;
    },
    // 下一条的点击事件
    nextClick() {
      if (!this.dataList[0].GID) {
        this.$dialog.alert({
          title: "提示",
          message: "没有下一条数据了"
        });
      } else {
        if (this.lastClickState) {
          this.getTicketSalePayment("next", this.lastClickOpDate);
          this.lastClickState = false;
        } else {
          this.getTicketSalePayment("next", this.dataList[0].PaymentTime);
        }
      }
    },
    // 点击打印事件
    printClick() {
      if (!this.dataList[0].PaymentTime) {
        this.$dialog.alert({
          title: "提示",
          message: "该缴款单还未提交缴款，请先提交缴款，再打印缴款单"
        });
      } else {
        let params = {
          GID: this.GID,
          OperGID: this.OperObj.GID, //操作员GID
          OperCode: this.OperObj.UserCode, //操作员代码
          OperName: this.OperObj.UserName //操作员名称
        };
        this.$http
          .post(
            this.$api.TicketSalePaymentPrintQuery,
            this.$qs.stringify(params)
          )
          .then(res => {
            console.log(res);
            setTimeout(() => {
              let data = res.data;
              if (data.length < 1) {
                this.$toast("未获取到数据");
              } else {
                this.$toast("请稍等，正在准备打印");
              }
              this.onPrintTicket(data);
            }, 1200);
          })
          .catch(err => {
            console.log(err);
            this.$dialog.alert({
              title: "提示",
              message: err
            });
          });
      }
    },
    // 打印票据
    onPrintTicket(obj) {
      //找到画布的元素
      if (!window.framework) {
        this.$toast.fail("请在手持机上开启打印功能");
        return;
      }
      // JSON 格式数据
      var jsonArray = [];
      jsonArray.push(
        {
          type: 1,
          size: 2,
          data:
            "    " +
            obj.PrintTitleName.slice(0, 7) +
            "\n    " +
            obj.PrintTitleName.slice(7, 12) +
            ""
        },
        {
          type: 1,
          data:
            "      缴款单号：" +
            obj.PaymentNo +
            "\n售票开始时间：\n" +
            obj.SaleBeginDateTime +
            ""
        },
        {
          type: 1,
          data: "售票截止时间：\n" + obj.SaleEndDateTime + "\n"
        },
        {
          type: 1,
          data:
            "售  票  员  ：" +
            obj.SellerName +
            "\n售 票 张 数 ：" +
            obj.ChargeTicketCount +
            "\n"
        },
        {
          type: 1,
          data:
            "售 票 金 额 ：" +
            obj.ChargeTicketAmount +
            "\n扫 码 金 额 ：" +
            obj.NonCashTicketAmount +
            "\n现 金 金 额 ：" +
            obj.CashTicketAmount +
            "\n"
        },
        {
          type: 1,
          data:
            "退 票 张 数 ：" +
            obj.RefundTicketCount +
            "\n退 票 金 额 ：" +
            obj.RefundTicketAmount +
            "\n"
        },
        {
          type: 1,
          data:
            "退票手续费  ：" +
            obj.RefundTicketFee +
            "\n应缴款金额  ：" +
            obj.PaymentAmount +
            "\n"
        },
        {
          type: 1,
          data: "缴款金额大写：\n\n缴款金额小写：\n\n"
        },
        {
          type: 1,
          data: "        签字："
        },
        {
          type: 1,
          data: "\n\n\n"
        }
      );
      if (window.framework.jsPrintJsonData) {
        window.framework.jsPrintJsonData(JSON.stringify(jsonArray));
      } else {
        this.$toast("该手持机不支持的打印方法");
      }
    }
  },
  mounted() {
    this.getTicketSalePayment();
    if (window.framework) {
      // 连接打印机
      if (window.framework.isReadPrint) {
        window.framework.isReadPrint(true);
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  destroyed() {
    if (window.framework) {
      // 断开打印机
      if (window.framework.isReadPrint) {
        window.framework.isReadPrint(false);
      }
    }
  }
};
</script>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}
.SalePayment {
  width: 100%;
  height: auto;
  font-size: 0.44rem;
  > .aBlock {
    width: 100%;
    height: auto;
    background-color: #fff;
    > .title {
      widh: 100%;
      height: auto;
      font-size: 0.5rem;
      background-color: #999;
      color: #fff;
      padding: 0.2rem 0;
    }
    > .wrap {
      width: 100%;
      height: 1.6rem;
      line-height: 0.8rem;
      display: flex;
      justify-content: space-between;
      padding: 0.4rem;
      box-sizing: border-box;
      overflow: hidden;
      > span {
        display: inline-block;
        width: 4rem;
        text-align: left;
      }
      > input {
        flex: 1;
        height: auto;
        border: 1px solid #999;
        box-sizing: border-box;
        padding: 0.04rem 0.2rem;
        overflow: hidden;
      }
    }
    > .computed {
      width: 100%;
      height: auto;
      padding: 0.4rem;
      box-sizing: border-box;
      overflow: hidden;
      > div {
        width: 100%;
        text-align: center;
      }
      > div:nth-child(3) {
        margin-top: 0.4rem;
      }
      > input {
        width: 100%;
        height: 1rem;
        padding: 0.1rem;
        box-sizing: border-box;
        border: 1px solid #999;
        margin-top: 0.2rem;
        text-align: center;
      }
      > input:nth-child(2) {
        font-size: 0.32rem;
      }
    }
  }
  .SalePaymentSubmit,
  .print,
  .refresh,
  .last,
  .next {
    width: 2rem;
    height: auto;
    position: fixed;
    right: 0.2rem;
    bottom: 6.6rem;
    color: #fff;
    padding: 0.2rem 0;
    z-index: 2;
    font-size: 0.4rem;
    background-color: #2891e7;
    border: 1px solid #999;
    border-radius: 0.1rem;
  }
  .print {
    bottom: 5.2rem;
  }
  .refresh {
    bottom: 3.8rem;
  }
  .last {
    bottom: 2.4rem;
  }
  .next {
    bottom: 1rem;
  }
  .SalePaymentSubmitPopup {
    width: 70%;
    height: auto;
    text-align: center;
    border-radius: 0.2rem;
    > .tips {
      width: 100%;
      height: 1rem;
      line-height: 1rem;
      color: #fff;
      background-color: #999;
    }
    > .content {
      padding: 0.4rem 0;
    }
    > .btn {
      display: flex;
      justify-content: space-around;
      margin: 0.2rem 0;
      color: #fff;
      box-sizing: border-box;
      padding: 0 1rem;
      span {
        display: inline-block;
        padding: 0.2rem 0.3rem;
        background-color: #2891e7;
      }
      span:last-child {
        background-color: red;
      }
    }
  }
}
</style>
